import type { ReactNode } from "react";
import { createSearchMatcher } from "../../../../utils/search";

// Подчертава съвпаденията с търсения текст в името на продукта.
// Търсенето е многодумно И на „шльокавица" (виж `utils/search.ts` и филтъра в
// ItemCatalog) — затова диапазоните за оцветяване идват от СЪЩИЯ matcher, а не
// от търсене на самия текст на заявката („min" се оцветява в „Минерална").
// Споделен между ItemRow (списък) и ItemCard (грид) — филтър и highlight
// се сменят ЗАЕДНО.
export const highlightMatch = (text: string, searchTerm: string) => {
  const matcher = createSearchMatcher(searchTerm);
  if (matcher.isEmpty || !text) return text;

  const ranges = matcher.ranges(text);
  if (ranges.length === 0) return text;

  const parts: ReactNode[] = [];
  let cursor = 0;
  ranges.forEach((range, index) => {
    if (range.start > cursor) parts.push(text.slice(cursor, range.start));
    parts.push(
      <span
        key={index}
        className="font-extrabold text-pos-accent-ink"
      >
        {text.slice(range.start, range.end)}
      </span>,
    );
    cursor = range.end;
  });
  if (cursor < text.length) parts.push(text.slice(cursor));
  return parts;
};

// Оцветява съвпадението по PLU код в сивия суфикс „| {plu}" след името —
// цифрова заявка съвпада като ПРЕФИКС на кода (виж matchesPluCode в
// `utils/search.ts`), затова се оцветяват първите ѝ на брой цифри.
export const highlightPluCode = (pluCode: number, searchTerm: string) => {
  const digits = searchTerm.trim();
  const text = String(pluCode);
  if (!/^\d+$/.test(digits) || !text.startsWith(digits)) return text;
  return (
    <>
      <span className="font-extrabold text-pos-accent-ink">
        {text.slice(0, digits.length)}
      </span>
      {text.slice(digits.length)}
    </>
  );
};
